export default __webpack_public_path__ + "static/media/type_12_3.12b76ee3.svg";